import React from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

type Props = {
  password: string;
  setPassword: (password: string) => void;
  showPassword: boolean;
  setShowPassword: (show: boolean) => void;
  error?: string;
  placeholder?: string;
};

export const PasswordInput: React.FC<Props> = ({
  password,
  setPassword,
  showPassword,
  setShowPassword,
  error,
  placeholder = "Enter your password"
}) => (
  <div className="w-full">
    <div className="relative">
      <Input
        type={showPassword ? "text" : "password"}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder={placeholder}
        className={`h-12 px-6 pr-12 border-2 ${error ? 'border-destructive' : 'border-border'} transition-all duration-200 [&::-ms-reveal]:hidden [&::-webkit-credentials-auto-fill-button]:hidden`}
      />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-accent/50 rounded-md transition-colors"
        aria-label={showPassword ? "Hide password" : "Show password"}
      >
        {showPassword ? (
          <EyeOff className="h-5 w-5 text-muted-foreground" />
        ) : (
          <Eye className="h-5 w-5 text-muted-foreground" />
        )}
      </button>
    </div>
    {error && (
      <p className="text-destructive text-xs mt-1 animate-in fade-in slide-in-from-top-1 duration-200">
        {error}
      </p>
    )}
  </div>
);
